import { TabSwitch, VStack } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import React, { useState } from 'react';

import { Movement } from './components/Movement';
import { Reports } from './components/Reports';
import { Statements } from './components/Statements';

export const Transactions: React.FC = () => {
  const transactionsTabs = [
    {
      key: 'movement',
      label: 'Movimentação',
      component: <Movement />,
    },
    {
      key: 'statements',
      label: 'Extratos',
      component: <Statements />,
    },
    {
      key: 'reports',
      label: 'Relatórios',
      component: <Reports />,
    },
  ];

  const transactionsInitialTab = transactionsTabs[0].key;

  const [selectedTab, setSelectedTab] = useState(transactionsInitialTab);

  const isMobile = useBreakpointValue({
    base: true,
    sm: false,
  });

  return (
    <VStack flex={1}>
      <TabSwitch
        testId="tab-switch-transactions"
        tabs={transactionsTabs}
        selectedTab={selectedTab}
        onTabPress={setSelectedTab}
        isMobile={isMobile}
        isLoading={false}
      />
    </VStack>
  );
};
